// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3lqkW","vLegacy":"SelectSecondary_vLegacy__1nKF2","error":"SelectSecondary_error__2h8sh","disabled":"SelectSecondary_disabled__ZU8fU"};